import Reactor from 'data/reactor';
import Actions from 'data/actions';
import Getters from 'data/getters';
import SessionStorageUtils from './data/session-storage/utils';
import DataLoader from 'data/loader';
import ga from 'utils/react-google-analytics';
import Analytics from 'utils/analytics';
import Cookies from 'js-cookie';
import { convertMeasurementScaleToSPv2Subject } from 'resources/common-values';

function onUpdate(props) {
    if (__GA__) {
        let path = Analytics.sanitizePath(props.location.pathname);
        Analytics.recordPageView(path);
    }
}

function onProfileEnter(props) {
    Actions.runtime.setSingleStudentSearchRendering(false);
    if (!props.location.state || !props.location.state.studentBid) {
        props.navigate('/students', { replace: true });
    } else {
        DataLoader.loadStudentProfileData(props.location.state.studentBid)
            .then((redirectToStudentSelection) => {
                if (redirectToStudentSelection) {
                    props.navigate('/students', { replace: true });
                }
            })
            .catch(() => {});
    }
}

function onProfileEnterSingleStudent(props) {
    //Re-initialize the display settings, setting single student search to true
    Actions.runtime.resetDisplaySettingsForSingleStudentSearch();

    /* Start off by loading partner data based on the current user. Adds necessary data like partnerBid to store. */
    DataLoader.loadStudentSelectionData()
        .then(async () => {
            let studentBid;
            // A student bid along with course and term data supplied via CPR student link
            let studentContext;
            const studentContextString = Cookies.get('sp_studentBID');
            const decodedStudentContextString = decodeURIComponent(studentContextString);
            if (decodedStudentContextString.includes('{')) {
                studentContext = JSON.parse(decodedStudentContextString);
                studentBid = studentContext.studentBid;
                Cookies.remove('sp_studentBID', { path: '/nextgen-report', domain: '.mapnwea.org' });
                /**
                 * CPR object { // example
                 * studentBid: '123abc', // string
                 * termNumber: 202104, // number
                 * measurementScale: "100" // string
                 * }
                 */
            } else {
                // A simple student bid supplied via the quicksearch link/reporting app
                studentBid = studentContextString;
                Cookies.remove('sp_studentBID', {
                    path: '/nextgen-report/single-student',
                });
            }

            if (!studentBid) {
                console.error(
                    'Was not able to find appropriate cookie to load single student. Redirecting to student selection screen.'
                );
                props.navigate('/students', { replace: true });
            }

            // Add studentBid to nextState so that onProfileEnter can continue like it does during the dropdown screen flow
            props.location.state = props.location.state || {};
            props.location.state.studentBid = studentBid;

            // Set studentBid in the store and load student data based on that studentBid
            Actions.roster.selectStudentBid(studentBid);
            let customCallBack;
            if (studentContext) {
                // Create a callback to trigger subject and term selection on student load
                customCallBack = () => {
                    Reactor.batch(() => {
                        Actions.student.changeSelectedTermNumber(studentBid, studentContext.termNumber);
                        Actions.runtime.changeSelectedSubject(
                            convertMeasurementScaleToSPv2Subject(studentContext.measurementScale),
                            true
                        );
                    });
                };
            }

            DataLoader.loadStudents(props.location.state.studentBid, customCallBack);
        })
        .catch((err) => {
            console.error(
                'Caught errors when trying to load student selection data when skipping dropdown screen',
                err
            );
            props.navigate('/students', { replace: true });
        });
}

function onStudentSelectionEnter() {
    if (Reactor.evaluate(Getters.runtime.singleStudentSearchRendering)) {
        console.warn(
            'Typical Student Profile navigation was attempted while the environment was expecting Single Student. Clearing state.'
        );
        SessionStorageUtils.clearStudentData();
        //Batch dispatches to nuclear stores
        Reactor.batch(() => {
            Actions.roster.clearRosterData(),
                Actions.student.clearStudentData(),
                Actions.runtime.setSingleStudentSearchRendering(false);
        });
    }
    DataLoader.loadStudentSelectionData().catch(() => {});
}

export { onProfileEnter, onUpdate, onProfileEnterSingleStudent, onStudentSelectionEnter };
